import { render, staticRenderFns } from "./modal-upload-folder.vue?vue&type=template&id=61d0e972&scoped=true&"
import script from "./modal-upload-folder.vue?vue&type=script&lang=js&"
export * from "./modal-upload-folder.vue?vue&type=script&lang=js&"
import style0 from "./modal-upload-folder.vue?vue&type=style&index=0&id=61d0e972&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d0e972",
  null
  
)

export default component.exports